// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_hk","advertCardNum":"c-a_hl"};